import { useClient } from 'hooks/useClient';
import { useMutation } from 'react-query';
import { useToast } from '@chakra-ui/react';
import { ERROR_TOAST_DEFAULTS, SUCCESS_TOAST_DEFAULTS } from '@helpers';
import { useEffect } from 'react';
import { translations } from 'translations';
import { useTranslation } from 'react-i18next';
import { useSession } from 'store/session';
import { getSessionTokenV3 } from 'helpers/sessionContext';


export const usePostCsv = () => {
  const client = useClient({
    token: getSessionTokenV3() as string,
    url: process.env.REACT_APP_API_V3,
  });

  const toast = useToast();

  const { team } = useSession();

  const { t } = useTranslation();

  const teamUUID = team?.uuid as string;

  const fn = async (payload: File) => {
    await client.createContacts(teamUUID, payload);

    const MESSAGE = t(translations.CONTACTS.POST_SUCCESS);

    toast({ ...SUCCESS_TOAST_DEFAULTS, title: MESSAGE });
  };

  const mutation = useMutation(['post-contacts-csv', teamUUID], fn);

  useEffect(() => {
    if (mutation.isError) {
      const MESSAGE = t(translations.ERRORS.NETWORK_DEFAULT);
      toast({ ...ERROR_TOAST_DEFAULTS, title: MESSAGE });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mutation.isError]);

  return { ...mutation };
};
